
import { motion } from "framer-motion";
import { Mail, Video, Gift, Camera } from "lucide-react";
import { useNavigate } from "react-router-dom";
export const HeroSection = () => {
  const navigate = useNavigate();
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const reloadPage = () => {
    window.location.reload();
  };
  return <>
      <motion.header initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="fixed top-0 left-0 right-0 bg-white shadow-md z-50 px-8 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <img src="/lovable-uploads/9f67b8b9-3b09-4bc9-98ae-93e6cef4e54a.png" alt="MyMontage Logo" className="h-12 cursor-pointer hover:opacity-80 transition-opacity" onClick={reloadPage} />
          <nav className="flex items-center space-x-8">
            <div className="hidden md:flex space-x-8">
              {[{
              title: 'Features',
              id: 'features'
            }, {
              title: 'How It Works',
              id: 'process'
            }, {
              title: 'Sample Video',
              id: 'sample'
            }, {
              title: 'Pricing',
              id: 'pricing'
            }, {
              title: 'Order',
              id: 'order'
            }, {
              title: 'Contact',
              id: 'contact'
            }].map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-navy-800 hover:text-navy-600 font-medium transition-colors">
                  {item.title}
                </button>)}
            </div>
            <button onClick={() => navigate('/login')} className="bg-navy-600 text-white px-4 py-2 rounded hover:bg-navy-700 transition-colors">
              Log In
            </button>
          </nav>
        </div>
      </motion.header>

      <section className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-navy-950 to-navy-800 text-white p-4 pt-24">
        <div className="max-w-4xl mx-auto text-center">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-5xl md:text-6xl font-bold mb-6">
            Professional Video Montages
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-xl md:text-2xl text-gray-300 mb-4">
            Montages That Speak, Memories That Stay.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-xl md:text-2xl text-gray-300 mb-8">
            Transform your memories into stunning video montages up to crystal clear 8K resolution starting at only $150 to accommodate any budget.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="space-y-6">
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Our expert team crafts beautiful video montages that bring your photos and videos to life. 
              Perfect for weddings, Bar/Bat Mitzvahs, anniversaries, birthdays, and any special occasion.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 text-center">
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-navy-800/50 p-6 rounded-lg transform transition-all duration-300 hover:shadow-lg">
                <Camera className="w-8 h-8 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">High Quality</h3>
                <p>Up to 8K resolution for crystal clear playback on any device</p>
              </motion.div>
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-navy-800/50 p-6 rounded-lg transform transition-all duration-300 hover:shadow-lg">
                <Video className="w-8 h-8 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">Delivery Time</h3>
                <p>Receive your montage within 1-2 weeks after all media is uploaded</p>
              </motion.div>
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-navy-800/50 p-6 rounded-lg transform transition-all duration-300 hover:shadow-lg">
                <Gift className="w-8 h-8 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-3">Custom Music</h3>
                <p>Choose from our library or provide your own soundtrack</p>
              </motion.div>
            </div>
            <motion.button whileHover={{
            scale: 1.05
          }} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.8
          }} onClick={() => scrollToSection('pricing')} className="inline-block bg-white text-navy-800 px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-100 transition-colors">
              View Our Packages
            </motion.button>
          </motion.div>
        </div>
      </section>
    </>;
};
